



import './axiosSetup';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './globalResponsive.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { registerWebToken } from './firebase';
import { ThemeProvider, CssBaseline } from '@mui/material';
import globalResponsiveTheme from './globalResponsiveTheme'; 

// Service Worker registration
if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .register('/firebase-messaging-sw.js')
    .then((registration) => {
      console.log('Service Worker registered:', registration);
      registerWebToken();
    })
    .catch((err) => {
      console.error('Service Worker registration failed:', err);
    });
} else {
  console.log('Service workers are not supported.');
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={globalResponsiveTheme}>
      <CssBaseline /> 
      <App />
    </ThemeProvider>
  </React.StrictMode>
);

reportWebVitals();